__webpack_require__.p = "/web_chat/";